<div class="d-flex flex-column flex-shrink-0 p-2 text-light bg-white sidebar section-side-nav" >
    <a href="/" class="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-light text-decoration-none">
        <a class="navbar-brand ps-md-4 me-auto pb-0 pt-4" routerLink="/admins/users/home"><img height="30px" style="margin-top: -10px;" src="../../assets/images/formed_logo_w.png"> </a>
    
    </a>
    <hr>
    <ul class="nav nav-pills flex-column mb-auto list-unstyled">
      <li class="nav-item">
        <a routerLink="/admin/dashboard" class="nav-link text-light" aria-current="page">
            <i class="far fa-home me-2" ></i>Koti
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/admins/admin/openings" class="nav-link text-light" aria-current="page">
            <i class="fal fa-briefcase me-2" ></i>Työpaikat
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/admins/admin/bills" class="nav-link text-light" aria-current="page">
            <i class="fal fa-file me-2" ></i>Laskutus
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/admins/admin/cooperation-codes" class="nav-link text-light" aria-current="page">
            <i class="fal fa-dollar-sign me-2" ></i>Koodit
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/admins/admin/companies" class="nav-link text-light" aria-current="page">
            <i class="fas fa-building me-2" ></i>Yritykset
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/admins/admin/params" class="nav-link text-light" aria-current="page">
            <i class="fas fa-indent me-2" ></i>Ohjaustiedot
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/admins/admin/translations" class="nav-link text-light" aria-current="page">
            <i class="fas fa-language me-2" ></i>Käännökset
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/admins/admin/consumerProducts" class="nav-link text-light" aria-current="page">
            <i class="fas fa-shopping-basket me-2" ></i>Kuluttajatuotteet
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/admins/admin/validateCompany" class="nav-link text-light" aria-current="page">
            <i class="fas fa-user-secret me-2" ></i>Org. Varmennus
        </a>
      </li>
<!--       <li class="nav-item">
        <a routerLink="/admins/admin/jobtitles" class="nav-link text-light" aria-current="page">
            <i class="fas fa-id-card me-2" ></i>Tehtävänimikkeet
        </a>
      </li> -->
      <li class="nav-item">
        <a routerLink="/admins/admin/skills" class="nav-link text-light" aria-current="page">
            <i class="fas fa-brain me-2" ></i>Skills
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/admins/admin/schools" class="nav-link text-light" aria-current="page">
            <i class="fas fa-school me-2" ></i>Koulut
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/admins/admin/articles" class="nav-link text-light" aria-current="page">
            <i class="fas fa-newspaper me-2" ></i>Artikkelit
        </a>
      </li>
    </ul>
    <div class="dropdown">
        <a href="#" class="d-flex align-items-center text-light text-decoration-none dropdown-toggle" id="dropdownUser1" data-bs-toggle="dropdown" aria-expanded="false">
          <img src="../../assets/images/formed_favicon.png" alt="" width="32" height="32" class="rounded-circle me-2">
          <strong>Profiili</strong>
        </a>
        <ul class="dropdown-menu dropdown-menu-dark text-small shadow" aria-labelledby="dropdownUser1">
          <li><hr class="dropdown-divider"></li>
          <li><a class="dropdown-item" (click)="doLogout()">Kirjaudu ulos</a></li>
        </ul>
      </div>
  </div> 